import {
  ClientContactField,
  IClientDTO,
  IJob,
  IJobCandidateInteraction,
  IJobSearchFilterDTO,
  JobAssignmentStatusFilter,
} from 'wisestep-api';

export interface JobSearchFilter
  extends Omit<IJobSearchFilterDTO, 'clientNames' | 'clientRecruiterEmails'> {
  clientList: IClientDTO[];
  clientRecruiterList: ClientContactField[];
}

export const defaultQuery: JobSearchFilter = {
  currentStageCurrentStatusPairs: '',
  clientList: [],
  clientRecruiterList: [],
  locations: [],
  clientName: '',
  jobAssignmentStatusFilter: JobAssignmentStatusFilter.Everything,
  jobStatus: 'All',
  excludeAddingLoggedInUserAsRecruiterIdByDefault: false,
  recruiterPartnerEmail: '',
  postedByRecruiterEmails: [],
  recruiterPartnerName: '',
  postedByTeams: '',
  notFromTeams: '',
  assignedToRecruiters: '',
  query: '',
  page: 0,
  size: 20,
  sort: [],
  jobType: '',
  postedOnJobBoards: '',
  postedByAccountManagerEmails: [],
  tags: [],
  jobCodes: [],
  accountManagerName: '',
  clientRecruiterName: '',
  assignedBy: '',
  jobIds: [],
  searchAcross: ['MY_TEAMS', 'MY_PERSONAL_DATA'],
  skills: [],
  jobCloseReason: '',
  industry: '',
  searchAcrossTeams: [],
  datesUnionBy: '',
  workspaceId: '',
  postedOnJobBoardBy: [],
  workplacePreference: '',
};

export const candidateStatsDefaultQuery: IJobCandidateInteraction = {
  jobIds: '',
  searchScope: 'EVERYWHERE',
  submittedByRecruiterIds: [],
  submittedAsTeamMemberEmails: [],
  jobCandidateMapping: false,
  searchAcrossJobPostingTeams: [],
  tags: [],
  candidateSearchType: 'All',
  employers: [],
  currentEmployers: [],
  skills: [],
  searchAcross: ['ACROSS_WORKSPACE'],
  aggregationFields: [
    'MAPPINGS_BY_JOB',
    'SUBMISSIONS_BY_JOB',
    'APPLICATIONS_BY_JOB',
    'UPLOADED_BY_JOB',
  ],
  noticePeriodMinDays: 0,
  noticePeriodMaxDays: 0,
  page: 0,
  size: 20,
  sort: ['createdOn,desc'],
  jobClientRecruiterEmails: [],
  jobAccountManagerEmails: [],
  languages: [],
  sources: [],
  jobTitles: [],
  queryType: 'none',
  query: '',
};

export interface JobStatusCount {
  all: string;
  open: string;
  closed: string;
}
export interface CandidateStats {
  jobId: string;
  mapped: number | string;
  applied: number | string;
  submitted: number | string;
}

export const similarJobsDefaultQuery = (job: IJob): IJobCandidateInteraction => {
  return {
    jobSearchFields: ['mappedJobTitle'],
    sourceJobCode: job.jobCode ?? '',
    searchAcross: ['ACROSS_WORKSPACE'],
    candidateSearchType: 'None',
    candidateSearchTypeList: ['submitted', 'mapped'],
    aggregationFields: ['SUBMISSIONS_BY_JOB'],
    // createdFromDate: '2022-01-20T11:54:21.902Z',
    jobTitles: [job.title ?? ''],
    skills: job.skills,
    jobLocations: job.locations,
    page: 1,
  };
};

export const similarJobsDefaultQueryJobSearch = (job: IJob) => {
  const locations = job.locations?.map((location) => {
    return {
      city: '',
      continent: '',
      continentCode: '',
      countryCode: '',
      state: '',
      stateCode: '',
      country: location.country,
    };
  });
  const date = new Date();
  date.setFullYear(date.getFullYear() - 3);
  return {
    jobStatus: 'All',
    jobTitle: job.title,
    locations: locations ?? [],
    skills: job.skills,
    jobsLike: job.id,
    searchAcross: ['ACROSS_WORKSPACE'],
    postedFromDate: date,
    postedToDate: new Date(),
    sort: ['_score,desc'],
    page: 0,
    size: 10,
  };
};

export interface keyPair {
  [key: string]: string | null;
}
export interface candidateStatesES {
  APPLICATIONS_BY_JOB: keyPair;
  MAPPINGS_BY_JOB: keyPair;
  SUBMISSIONS_BY_JOB: keyPair;
  UPLOADED_BY_JOB: keyPair;
}

export interface jobCrmStatesCount {
  jobId?: string;
  mappingsByJob: number;
  applicationsByJob: number;
  uploadedByJob: number;
  submissionsByJob: number;
}
